export default "__VITE_ASSET__KC4PDXpP__"